module.exports = __webpack_public_path__ + "static/media/top1_off.5c47423c.png";